interface KakaoSdk {
  init: (key: string) => void;
  isInitialized: () => boolean;
  Share: {
    sendDefault: (settings: {
      objectType: 'text';
      text: string;
      link: { mobileWebUrl: string; webUrl: string };
    }) => void;
  };
}

const SDK_URL = 'https://t1.kakaocdn.net/kakao_js_sdk/2.8.4/kakao.min.js';
const SDK_INTEGRITY = 'sha384-BGX7Wb16GmRFagri4bLJV2DgipVZaU2AI812GZtHtHzzDQJnfHasDXN5houxv45w';
let sdkPromise: Promise<KakaoSdk> | null = null;

function getKakao(): KakaoSdk | undefined {
  return (window as Window & { Kakao?: KakaoSdk }).Kakao;
}

function loadKakao(): Promise<KakaoSdk> {
  const existing = getKakao();
  if (existing) return Promise.resolve(existing);
  if (sdkPromise) return sdkPromise;

  sdkPromise = new Promise<KakaoSdk>((resolve, reject) => {
    const script = document.createElement('script');
    script.src = SDK_URL;
    script.integrity = SDK_INTEGRITY;
    script.crossOrigin = 'anonymous';
    script.onload = () => {
      const kakao = getKakao();
      if (kakao) resolve(kakao);
      else reject(new Error('카카오 SDK를 사용할 수 없습니다.'));
    };
    script.onerror = () => reject(new Error('카카오 SDK를 불러오지 못했습니다.'));
    document.head.appendChild(script);
  }).catch(error => {
    sdkPromise = null;
    document.querySelector(`script[src="${SDK_URL}"]`)?.remove();
    throw error;
  });
  return sdkPromise;
}

export async function sharePromotionOnKakao(title: string, url: string, key: string): Promise<void> {
  const kakao = await loadKakao();
  if (!kakao.isInitialized()) kakao.init(key);
  kakao.Share.sendDefault({
    objectType: 'text',
    text: title,
    link: { mobileWebUrl: url, webUrl: url },
  });
}
